export default __webpack_public_path__ + "42e7b54d9c69ea0b2bbc762d2a6f0d68.svg";